var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 23.25V33.25H42L47 43.25L50.75 42",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 23.25C30.3211 23.25 32 21.5711 32 19.5C32 17.4289 30.3211 15.75 28.25 15.75C26.1789 15.75 24.5 17.4289 24.5 19.5C24.5 21.5711 26.1789 23.25 28.25 23.25Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 27H29.5C26.8478 27 24.3043 28.0536 22.4289 29.9289C20.5536 31.8043 19.5 34.3478 19.5 37C19.5 39.6522 20.5536 42.1957 22.4289 44.0711C24.3043 45.9464 26.8478 47 29.5 47C34.1594 47 38.3906 43.8125 39.5 39.5",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.d1e52bb1b609fb405532c86268fbd0bc.svg";
export { ForwardRef as ReactComponent };